import { combineReducers } from "redux";

import loader from "./loader";
import login from "./login";

export default combineReducers({
  login,
  loader,
});
